import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Subscription } from "rxjs";
import { OPD_CONST } from "../../properties/opd-static-properties";
import { OPD_API_URL } from "../../properties/opd-url-properties";
import { GeneralUrlService } from "../../services/SgeneralUrl.service";
import { MergePatientService } from "../../services/Smerge-patient.service";
import { MatPaginator } from "@angular/material/paginator";
import { FormControl } from "@angular/forms";
import { SearchHeaderService } from "../../services/SsearchHeader.service";
import { ERStatusColor, Merged, REPORT_NAME } from "../../enums/encounter-status.enum";
import { opdNavigation } from "../../properties/opd-navigation-properties";
import { OPD_REPORT_TYPE } from "../../properties/opd-report-properties";
import { Configuration } from "projects/lib/medcare-core-lib/src/lib/shared/Configuration";
import { MICROSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/web-services";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";
import { SearchService } from "projects/lib/medcare-core-lib/src/lib/services/search.service";
import { DatePipe } from "@angular/common";
import { thEnConverterService } from "projects/lib/medcare-core-lib/src/lib/services/thEnConverterService";
import { Langauge } from "projects/lib/medcare-core-lib/src/lib/enums/configuration-modules.enum";

@Component({
  selector: "app-patient-merge-list",
  templateUrl: "./patient-merge-list.component.html",
  styleUrls: ["./patient-merge-list.component.scss"],
  providers:[DatePipe]
})
export class PatientMergeListComponent implements OnInit, OnDestroy {
  selectedPatient: any;
  displayedColumns: any[] = OPD_CONST.displayColumnMergeList;
  displayedColumnUnmerged: any[] = OPD_CONST.displayColumnMergeUnmergedList;
  dataSource = new MatTableDataSource<any>();
  dataSourceHistory = new MatTableDataSource<any>();
  patientMergeList: any = [];
  private subscriptionList = new Subscription();
  reason: string;
  remarks: string;
  reasonSample: any[] = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  totalDataLength: number = 0;
  pageSize: number = 0;
  paginatorOptions: any;
  offsetData: number = 0;
  pageIndex: number = 1;
  reasonList: any[]=[];
  reasonSearch: FormControl = new FormControl();
  searchResult: {
    primaryMrn: string;
    primaryName: string;
    secondaryMrn: string;
    secondaryName: string;
    merged:string;
  } = {
    primaryMrn: "",
    primaryName: "",
    secondaryMrn: "",
    secondaryName: "",
    merged:""
  };
  selectedTab: number =0;
  activeTab: number =0;
  patientMergeUnmergedList:any;
  isButtonShow: boolean = false;
  tabReportName:string=REPORT_NAME.MERGE;
  langaugeValue:string="";
  constructor(
    public mergeService: MergePatientService,
    public generalApiService: GeneralUrlService,
    public snackBar: MatSnackBar,
    private langService: MultiLanguageService,
    public appBaseService: AppBaseService,
    public searchHead: SearchHeaderService,
    private searchService: SearchService,
    private thConvertService:thEnConverterService,
    public datePipe: DatePipe,

  ) {}

  /**
   *load method
   *
   * @memberof PatientMergeListComponent
   */
  ngOnInit(): void {
    this.pageSize = Configuration.PAGINATOR_DEFAULT;
    this.initSearchFilter();
    this.paginatorOptions = Configuration.PAGINATOR_OPTIONS;
    this.langaugeValue=localStorage.getItem("lan");
    this.getmergePatientList();
    this.getReasonList();
    this.onChanges();
    
  }
  onChanges() {
    this.subscriptionList.add(
      this.reasonSearch.valueChanges.subscribe((value) => {
        this.reasonSample = this.reasonList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
  }
  /**
   *Selected row
   *
   * @param {*} row
   * @memberof PatientBlockingComponent
   */
  selectedRow(row) {
    this.selectedPatient = row;
  }

  getNext(event) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.offsetData = event.pageIndex * event.pageSize;
    if((this.selectedTab == 0)){
      this.getmergePatientList();
    }else if((this.selectedTab == 1)){
      this.setPageData();
    }
  }

  /**
   *It is the source of Reason data
   *
   * @memberof PatientRegistrationComponent
   */
  getReasonList() {
    this.appBaseService.setResourceURL(MICROSERVICES.MASTERS_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.M_REASON_MASTER_QUERY_NEW+"UNMR",true)
      .subscribe((res) => {
        res.forEach((element) => {
          this.reasonSample.push(element);
          this.reasonList.push(element);
        });
      });
  }
  setTab($event) {
    this.selectedTab = $event.index;
    if (this.selectedTab == 0) {
      this.tabReportName=REPORT_NAME.MERGE;
      this.isButtonShow = false;
      this.patientMergeList=[];
      this.patientMergeUnmergedList = [];
      this.totalDataLength =0;
      this.offsetData=0;
      this.searchResult.primaryMrn="";
      this.searchResult.primaryName="";
      this.searchResult.secondaryMrn="";
      this.searchResult.secondaryName="";
      this.searchResult.merged="";
      this.dataSource = new MatTableDataSource();
      this.getmergePatientList();
      this.initSearchFilter();
    }
    else if (this.selectedTab == 1) {
      this.tabReportName=REPORT_NAME.MERGE_UNMERGE;
      this.isButtonShow = true;
      this.patientMergeList=[];
      this.patientMergeUnmergedList = [];
      this.totalDataLength =0;
      this.searchResult.primaryMrn="";
      this.searchResult.primaryName="";
      this.searchResult.secondaryMrn="";
      this.searchResult.secondaryName="";
      this.searchResult.merged = "";
      this.dataSourceHistory = new MatTableDataSource();
      this.getmergeUnmergedPatientList();
    }
  }

  /**
   *Get merged data
   *
   * @memberof PatientMergeListComponent
   */
  getmergePatientList() {
    let mergedStatus="";
    mergedStatus = (this.searchResult.merged === Merged.UnMerged) 
              ? Merged.unmerged : Merged.merged;
    let reqPayload = mergedStatus+"=true&offset=" +this.offsetData +"&size=" +this.pageSize+
    "&primaryPatientName="+this.searchResult.primaryName+"&primaryPatientMrn="+this.searchResult.primaryMrn+"&name="+this.searchResult.secondaryName+"&mrn="+this.searchResult.secondaryMrn
    this.subscriptionList.add(
      this.generalApiService
        .getTypeApi(
          OPD_API_URL.OPD_SERVICE,
          OPD_API_URL.OPD_PATIENT_SEARCH_NEW + reqPayload
        )
        .subscribe((result: any) => {
          this.totalDataLength = result.totalRecords;
          this.patientMergeList = this.mergeService.patientMergeList(result.patientDetailResponseList);
          this.patientMergeList.forEach(element => {
            element.primaryDob= element.primaryDob
          ? (this.langaugeValue == Langauge.TH
            ? this.thConvertService.convertThaiDateString(element.primaryDob.toString())
            : this.datePipe.transform(element.primaryDob, "dd-MM-yyyy"))
          : null,
          element.secondaryDob= element.secondaryDob
          ? (this.langaugeValue == Langauge.TH
            ? this.thConvertService.convertThaiDateString(element.secondaryDob)
            : this.datePipe.transform(element.secondaryDob, "dd-MM-yyyy"))
          : null
          element.mergedOn= element.mergedOn
          ? (this.langaugeValue == Langauge.TH
            ? this.thConvertService.convertThaiDateFormat(element.mergedOn)
            : this.datePipe.transform(element.mergedOn, "dd/MM/yyyy hh:mm aa"))
          : null
          });

          this.dataSource = new MatTableDataSource<any>(this.patientMergeList);
        })
    );
  }

  getmergeUnmergedPatientList() {
     let mergedStatus="";
     if(this.searchResult.merged==Merged.UnMerged){
      mergedStatus=Merged.unmerged+"=true&bothMergeUnmerge=";
    }else if(this.searchResult.merged==Merged.Merged){
      mergedStatus=Merged.merged+"=true&bothMergeUnmerge=";
    }else{
      mergedStatus="bothMergeUnmerge=true"
    }
    let reqPayload = mergedStatus+"&primaryPatientName="+this.searchResult.primaryName+"&primaryPatientMrn="+this.searchResult.primaryMrn
    +"&secondaryPatientName="+this.searchResult.secondaryName+"&secondaryPatientMrn="+this.searchResult.secondaryMrn
    this.subscriptionList.add(
      this.generalApiService
        .getTypeApi(
          OPD_API_URL.OPD_SERVICE,
          OPD_API_URL.OPD_PATIENT_SEARCH_HISTORY + reqPayload
        )
        .subscribe((result: any) => {
          this.totalDataLength = result.count;
          this.patientMergeUnmergedList = this.mergeService.patientMergeUnmergedList(result.patientMergeUnMergeResponseList);
          this.patientMergeUnmergedList.forEach(element => {
            element.secondaryDob= element.secondaryDob
          ? (this.langaugeValue == Langauge.TH
            ? this.thConvertService.convertToThaiFullDateWithOutTime(element.secondaryDob)
            : this.datePipe.transform(element.secondaryDob, "dd-MM-yyyy"))
          : null,
          element.primaryDob= element.primaryDob
          ? (this.langaugeValue == Langauge.TH
            ? this.thConvertService.convertToThaiFullDateWithOutTime(element.primaryDob)
            : this.datePipe.transform(element.primaryDob, "dd-MM-yyyy"))
          : null,
          element.performedOn= element.performedOn
          ? (this.langaugeValue == Langauge.TH
            ? this.thConvertService.convertToThaiFullDate(element.performedOn)
            : this.datePipe.transform(element.performedOn, "dd/MM/yyyy hh:mm aa"))
          : null
          });
          this.setPageData();
        })
    );
  }
  setPageData() {
    const startIndex = (this.pageIndex - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.dataSourceHistory = new MatTableDataSource<any>(this.patientMergeUnmergedList.slice(startIndex, endIndex));
  }

  /**
   *Unmerge patient
   *
   * @memberof PatientMergeListComponent
   */
  unMergePatient() {
    if (this.validateMerge()) {
      let resReason = this.reasonSample.find((s) => s.code == this.reason);
      let requestObject = {
        patientIdList: [this.selectedPatient.Id],
        remarks: this.remarks,
        reason: this.reason
          ? this.langService.createObjectList(resReason)
          : null,
      };
      this.subscriptionList.add(
        this.generalApiService
          .postTypeApi(
            OPD_API_URL.OPD_SERVICE,
            OPD_API_URL.OPD_UNMERGE,
            requestObject
          )
          .subscribe((response: any) => {
            if (response) {
              this.snackBar.open(
                //"Patient Unmerged Succesfully",
                this.langService.get("CommonAppoinment.patientunmerged"),
                this.langService.get("CommonAppoinment.success"),
                {
                  duration: 2000,
                }
              );
              this.reason = null;
              this.remarks = "";
              this.getmergePatientList();
            }
          })
      );
    }
  }

  /*Destroy method
   *
   * @memberof PatientRegistrationComponent
   */
  ngOnDestroy() {
    this.subscriptionList.unsubscribe();
  }

  /**
   *Validate condtions
   *
   * @return {*}  {boolean}
   * @memberof PatientMergeListComponent
   */
  validateMerge(): boolean {
    let valid = true;
    if (this.selectedPatient) {
      if (this.selectedPatient.status == "Unmerged") {
        valid = false;
        this.snackBar.open(
          //"Please Select Merged Patient only",
          this.langService.get("CommonAppoinment.selectmergedpatient"),
          this.langService.get("CommonAppoinment.warning"),
          {
            duration: 2000,
          }
        );
      } else if (!this.reason) {
        valid = false;
        this.snackBar.open(
          //"Please select Reaon",
          this.langService.get("CommonAppoinment.selectreason"),
          this.langService.get("CommonAppoinment.warning"),
          {
            duration: 2000,
          }
        );
      }
    } else {
      valid = false;
      this.snackBar.open(
        //"Please Select Patient",
        this.langService.get("CommonAppoinment.selectpatient"),
        this.langService.get("CommonAppoinment.warning"),
        {
          duration: 2000,
        }
      );
    }
    return valid;
  }

  initSearchFilter(){
    this.subscriptionList.add(
      this.searchHead.getTypeSearch(OPD_API_URL.MERGE_LIST_SEARCH).subscribe((data: any) => {
        this.searchHead.updateSearchHeader(data);
      })
    );
    this.subscriptionList.add(
      this.searchService.getResult.subscribe((result) => {
        if(result){
        this.searchResult.primaryMrn=result.primaryPatientMrn;
        this.searchResult.primaryName=result.primaryPatientName;
        this.searchResult.secondaryMrn=result.mrn;
        this.searchResult.secondaryName=result.name;
        this.searchResult.merged=result.Merged?result.Merged.desc:"";
        }
        if(this.selectedTab == 0){
          this.getmergePatientList();
        } else if(this.selectedTab == 1){
          this.getmergeUnmergedPatientList();
        }
      })
    );
   
  }
  refreshSearch(){
    this.patientMergeList=[];
    this.patientMergeUnmergedList = [];
    this.totalDataLength =0;
    this.offsetData=0;
    this.pageSize = 10;
    this.searchResult.primaryMrn="";
    this.searchResult.primaryName="";
    this.searchResult.secondaryMrn="";
    this.searchResult.secondaryName="";
    this.searchResult.merged="";
    if (this.selectedTab == 0) {
      this.isButtonShow = false;
      this.dataSource = new MatTableDataSource();
      this.getmergePatientList();
      this.initSearchFilter();
    }
    else if (this.selectedTab == 1) {
      this.isButtonShow = true;
      this.dataSourceHistory = new MatTableDataSource();
      this.getmergeUnmergedPatientList();
    }
  }
  onPrintClick(element){
    let reqPayload = {
      transactionId: element.Id,
      type: OPD_REPORT_TYPE.pdf,
      reportName: REPORT_NAME.PATIENT_WISE,
      isReports: false,
    };
    localStorage.removeItem(OPD_CONST.reportPayload);
    localStorage.setItem(OPD_CONST.reportPayload, JSON.stringify(reqPayload));
    window.open(opdNavigation.REPORT_NAVIGATE);
  }
  OnListPrint(){
    let reqPayload = {
      type: OPD_REPORT_TYPE.pdf,
      reportName: this.tabReportName
    };
    localStorage.removeItem(OPD_CONST.reportPayload);
    localStorage.setItem(OPD_CONST.reportPayload, JSON.stringify(reqPayload));
    window.open(opdNavigation.REPORT_NAVIGATE);
  }
  getstatusColor(status: string): { text: string; backgroundColor: string } {
    let style: { text: string; backgroundColor: string } = {
      text: status,  
      backgroundColor: "lightblue", 
    };
    switch (status) {
      case "Merged":
        style.text = "Merged";
        style.backgroundColor = ERStatusColor.requested;
        break;
      case "unMerged":
        style.text = "unMerged";
        style.backgroundColor = ERStatusColor.rejected;
        break;
    
      default:
        break;
    }
    return style;
  }

}